export const SUPPORT_TICKETS_QUERY_KEY = 'supportTickets';
export const SUPPORT_TICKET_QUERY_KEY = 'supportTicket';

export const supportTicketKeys = {
  list: (page?: number) => [SUPPORT_TICKETS_QUERY_KEY, page] as const,
  detail: (id: number | string) => [SUPPORT_TICKET_QUERY_KEY, id] as const,
};
